export interface FeatureFlags {
  announcements: boolean
  attachments: boolean
  dialIn: boolean
  playIn: boolean
  questions: boolean
  questionsPriority: boolean
  seatingOrder: boolean
  screenshare: boolean
  slides: boolean
  votes: boolean
  spotlight: boolean
  eventStream: boolean
  layouts: boolean
  [key: string]: boolean
}

const featureFlags: FeatureFlags = {
  announcements: true,
  attachments: true,
  dialIn: true,
  slides: true,
  playIn: true,
  questions: true,
  questionsPriority: true,
  screenshare: true,
  seatingOrder: true,
  votes: true,
  spotlight: true,
  eventStream: true,
  layouts: true
}

export default featureFlags
